<template>
  <div class="modal fade" ref="mdlOpcionesMenu" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog"  aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content" style="border:none">
        <div class="modal-header text-white bg-success d-flex justify-content-between">
          <div class="modal-title text-center">
            <strong style="font-size: 22px">
              Nueva opción de menú ({{ menu_personalizado.descripcion }})
            </strong>
            <sub>(Individual / Global)</sub>
          </div>
          <button class="btn btn-link text-white p-0" @click="cerrarModal()">
            <i class="mdi mdi-close mdi-24px"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label for="" class="form-label">
              Descripción
            </label>
            <input 
              ref="descripcion"
              type="text" 
              class="form-control"
              placeholder="Descripción de la opción de menú"
              v-model="opcion.descripcion"
            />
          </div>
          <div class="mb-3">
            <label for="" class="form-label">
              URL
            </label>
            <input 
              ref="url"
              type="url" 
              class="form-control"
              placeholder="URL de la opción de menú (https://google.com/)"
              v-model="opcion.url"
            />
          </div>
          <div class="row">                                                            
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label">
                  Icono
                </label>
                <multiselect
                  v-model="iconoSeleccionado"
                  :options="iconos"
                  label="nombre"
                  track-by="id"
                  placeholder="Selecciona o escribe para buscar un icono…"
                  selectLabel="Presione enter para seleccionar"
                  selectedLabel="Seleccionado"
                  deselectLabel="Presione enter para eliminar"
                  :searchable="true"
                  :internal-search="true"
                  :filter="filtrarIconos"
                >
                  <!-- Opciones del dropdown -->
                  <template #option="{ option }">
                    <div class="d-flex align-items-center">
                      <i :class="['mdi', option.mdi, 'me-3']"></i>
                      <span>{{ option.nombre }}</span>
                    </div>
                  </template>

                  <!-- Opción seleccionada -->
                  <template #singleLabel="{ option }">
                    <div class="d-flex align-items-center">
                      <i :class="['mdi', option.mdi, 'me-3']"></i>
                      <span>{{ option.nombre }}</span>
                    </div>
                  </template>
                  
                  <template #noResult>
                    No se encontraron iconos
                  </template>                  
                </multiselect>
              </div>
            </div>
            <div class="col-md-6">
                <div class="mb-3">
                    <label class="form-label">
                      Tipo
                    </label>
                    <select class="form-select" v-model="opcion.id_usuario">
                      <option :value="null">Global</option>
                      <option :value="usuario.id">Individual</option>
                    </select>
                </div>
            </div>
            <div class="col-md-4">
                <div class="mb-3">
                  <label class="form-label">Nueva ventana</label>
                  <div class="form-check form-switch form-switch-lg mb-3" dir="ltr">
                    <input 
                      v-model="opcion.nueva_ventana"
                      class="form-check-input"
                      type="checkbox"
                      id="nuevaVentana"
                    />
                    <label class="form-check-label" for="nuevaVentana"></label>
                  </div>
                </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="cerrarModal()">
            <i class="mdi mdi-close"></i>
            Cerrar
          </button>
          <button type="button" class="btn btn-success" @click="modo == 'nueva' ? guardar() : actualizar()" :disabled="bandera_spinner">
            <i 
              class="mdi"
              :class="!bandera_spinner ? 'mdi-content-save' : 'mdi-concourse-ci mdi-spin'"
            ></i>
            {{ modo == 'nueva' ? 'Guardar' : 'Actualizar' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OpcionMenuPersonalizadoSrv from "@/services/OpcionMenuPersonalizadoSrv.js"
import MenuPersonalizadoSrv from "@/services/MenuPersonalizadoSrv.js"
import Modal from 'bootstrap/js/dist/modal'
import Multiselect from 'vue-multiselect'
import iconsMdi from '@/icons/mdi'

export default {
  name: 'MdlOpciones',
  components: {
    Multiselect
  },

  data() {
    return {
      modo: 'nueva',
      id_opcion: null,
      opcion: {
        id: null,
        id_menu: null,
        descripcion: '',
        icono: '',
        url: '', 
        nueva_ventana: true,
        id_usuario: null
      },
      bandera_spinner: false,

      menu_personalizado: {
        id: null,
        descripcion: ''
      },

      iconoSeleccionado: null,
      iconos: iconsMdi
    }
  },

  computed: {
    usuario() {
      return this.$store.state.todo.usuario
    },
  },

  watch: {
    iconoSeleccionado(val) {
      this.opcion.icono = val ? val.mdi : null
    }
  },

  methods: {
    actualizar: function() {
      let self = this,
        opcion = self.opcion
      
      self.bandera_spinner = true

      if (opcion.descripcion == null || opcion.descripcion == '') {
        iu.msg.warning('Es necesario ingresar una descripción')
        self.$refs.descripcion.select()
        self.bandera_spinner = false
        return
      }

      if (opcion.url == null || opcion.url == '') {
        iu.msg.warning('La URL es obligatoria, ingresa una dirección válida')
        self.$refs.url.select()
        self.bandera_spinner = false
        return
      }

      if (opcion.url !== '') {
        let patron = /^(https?:\/\/)(([a-z0-9-]+\.)+[a-z]{2,}|(\d{1,3}\.){3}\d{1,3})(\/.*)?$/i;

        if (!patron.test(opcion.url)) {
          iu.msg.warning('Ingresa una URL válida (ej: https://google.com)')
          self.$refs.url.select()
          self.bandera_spinner = false
          return
        }
      }

      OpcionMenuPersonalizadoSrv.actualizar(opcion).then(response => {
        iu.msg.success('Se actualizo correctamente la opcion de menu')

        self.$emit("refrescar-opciones")
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo actualizar, intentalo nuevamente más tarde'
        }
        iu.msg.error(mensaje)
        console.log(error)
      }).finally(() => {
        self.bandera_spinner = false
        iu.bus.emit('actualizarOpciones')
      })
    },

    cargarOpcion: function() {
      var self = this,
        idOpcion = self.id_opcion

      OpcionMenuPersonalizadoSrv.opcionJSON(idOpcion).then(response => {
        self.opcion = response.data
        self.opcion.nueva_ventana = ["1", 1, "true", true].includes(response.data.nueva_ventana)

        self.iconoSeleccionado = self.iconos.find(i => i.mdi === self.opcion.icono)

      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo cargar la opcion de menu'
        }
        iu.msg.error(mensaje)
        console.log(error)
      })
    },

    cargarMenuPersonalizado: function() {
      var self = this

      MenuPersonalizadoSrv.actualJSON().then(response => {
        self.menu_personalizado = response.data
        self.opcion.id_menu = self.menu_personalizado.id
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo cargar la opcion de menu'
        }
        iu.msg.error(mensaje)
        console.log(error)
      })
    },

    cerrarModal: function() {
      document.activeElement?.blur() // Quita el foco del botón actual

      this.limpiar()
      
      var modal = Modal.getInstance(this.$refs.mdlOpcionesMenu)
      modal.hide()
    },

    filtrarIconos(opciones, search) {
      if (!search) return []

      search = search.toLowerCase()

      return opciones.filter(icono =>
        icono.nombre.toLowerCase().includes(search) ||
        icono.mdi.toLowerCase().includes(search)
      )
    },

    guardar: function() {
      let self = this,
        opcion = self.opcion
      
      self.bandera_spinner = true

      if (opcion.descripcion == null || opcion.descripcion == '') {
        iu.msg.warning('Es necesario ingresar una descripción')
        self.$refs.descripcion.select()
        self.bandera_spinner = false
        return
      }

      if (opcion.url == null || opcion.url == '') {
        iu.msg.warning('La URL es obligatoria, ingresa una dirección válida')
        self.$refs.url.select()
        self.bandera_spinner = false
        return
      }

      if (opcion.url !== '') {
        let patron = /^(https?:\/\/)(([a-z0-9-]+\.)+[a-z]{2,}|(\d{1,3}\.){3}\d{1,3})(\/.*)?$/i;

        if (!patron.test(opcion.url)) {
          iu.msg.warning('Ingresa una URL válida (ej: https://google.com)')
          self.$refs.url.select()
          self.bandera_spinner = false
          return
        }
      }

      OpcionMenuPersonalizadoSrv.guardar(opcion).then(response => {
        iu.msg.success('Se guardó correctamente la opcion de menu')

        self.$emit("refrescar-opciones")

        self.cerrarModal()
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo guardar, intentalo nuevamente más tarde'
        }
        iu.msg.error(mensaje)
        console.log(error)
      }).finally(() => {
        self.bandera_spinner = false
        iu.bus.emit('actualizarOpciones')
      })
    },

    mostrar: function(modo = 'nueva', idOpcion = null) {
      var self = this

      self.modo = modo

      if(modo == 'edicion' && idOpcion != null) {
        self.id_opcion = idOpcion
        self.cargarOpcion()
      }

      self.cargarMenuPersonalizado()

      var modal = new Modal(this.$refs.mdlOpcionesMenu)
      modal.show()
    },

    limpiar: function() {
      var self = this
      
      self.modo = 'nueva'
      
      self.id_opcion = null
      self.opcion = Object.assign(self.opcion, {
        id: null,
        id_menu: null,
        descripcion: '',
        icono: '',
        url: '', 
        nueva_ventana: true,
        id_usuario: null
      })

      self.menu_personalizado = Object.assign(self.menu_personalizado, {
        id: null,
        descripcion: ''
      })

      self.bandera_spinner = false
      self.iconoSeleccionado = null
    }
  }
}
</script>

<style scoped>
</style>